import { adminApi } from '@redux/api/adminApi';
import { advApi } from '@redux/api/advApi';
import reducer from '@redux/slices';
import { errorHandler as errorHandlerMiddleware } from '@redux/store/middlewares';
import { configureStore } from '@reduxjs/toolkit';

export function setUpStore() {
    return configureStore({
        reducer: {
            [adminApi.reducerPath]: adminApi.reducer,
            [advApi.reducerPath]: advApi.reducer,
            ...reducer,
        },
        middleware: (gDM) => gDM({ serializableCheck: false }).concat([adminApi.middleware, advApi.middleware, errorHandlerMiddleware]),
    });
}

const store = setUpStore();

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
